import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import { useHistory } from 'react-router';
import { divide, isBuffer } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import axios from 'axios';
import '../supportOpen/style.css';
import { CommonConfig } from '../../../config/common-config';
import token from '../../../config/token';
import { useLocation } from 'react-router-dom';
import SupportImage from '../../../assets/images/Support_image.png';
import StageInprogress from '../../../assets/images/Support_Inprogress.png';
import SupportOpen from '../../../assets/images/Support_Open.png';
import SupportCompleted from '../../../assets/images/Support_Completed.png';
// import PreviewImage from '../../../assets/previewImage.png';
import PreviewModal from '../../../components/modal/previewModal';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import downloadImage from '../../../assets/downloadImage.png';
import { setSelectedImc } from '../../services/store/actions/index';

const useStyles = makeStyles((theme) => ({
    supCardImg: {
        width: '100%',
        // height: '100%',
        // border: '1px solid black',
        // position: 'relative',
        '& img': {
            margin: '20px auto',
            display: 'block',
            // maxHeight: '100%',
            // maxWidth: '100%',
            // position: 'absolute',
            // top: '0',
            // bottom: '0',
            // left: '0',
            // right: '0',
            // margin: 'auto',
        },
    },
    heading: {
        fontFamily: 'Rubik',
        fontSize: '30px',
        fontWeight: 300,
        textAlign: 'center',
        color: '#515151',
        margin: '30px 0',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '100%',
    },
    btnspace: {
        marginTop: '10px',
    },
    txtnormal: {
        fontFamily: 'Rubik',
        fontSize: '15px',
    },
    txtbold: {
        fontWeight: '500',
        fontFamily: 'Rubik',
        fontSize: '15px',
    },
    fontstyle: {
        fontFamily: 'Rubik',
        fontSize: '15px',
    },
    overflowView: {
        overflowY: 'auto',
        overflowX: 'hidden',
        height: '200px',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
        width: '100%',
    },
    buttonView: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '24%',
        margin: '0px !important',
        background: '#4c4fa6 !important',
        color: 'white !important',
        marginRight: '14px !important',
        fontFamily: 'Rubik',
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '8px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
        pointerEvents: 'none',
    },
    widthView: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '14%',
        margin: '0px !important',
        background: '#4c4fa6 !important',
        color: 'white !important',
        marginRight: '8px !important',
        fontFamily: 'Rubik',
    },
}));

export default function SupportInprogress({ letter, index, handleSave }) {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();

    // const [body, setBody] = useState(letter.engagementBody);
    // const [subject, setSubject] = useState(letter.engagementSubject);

    const viewId = '1209';
    const tokens = token();
    const [selectedTicketVal, setSelectedTicketDetails] = useState(0);
    const [messagesList, setMessagesList] = useState({});
    const [messageStatus, setMessageStatus] = useState('');
    const [message, setMessage] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [issueType, setIssueType] = useState('');
    const [statusType, setStatusType] = useState('');
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const usertype = userDetails && userDetails.data && userDetails.data.userType;
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [openResolveModal, setOpenResolveModal] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const [domainname, setDomainName] = useState(location.state.imcType);
    // console.log("location.state.imcType", location.state.imcType);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const dispatch = useDispatch({});

    //console.log('SELECTED TICKET VALLL---------------', dbname);

    useEffect(() => {
        getTicketDetails();
    }, [tokens]);

    const getTicketDetails = () => {
        let baseURL = '';
        if (usertype === 'SUPERADMIN' || usertype === 'itec') {
            if (location.state.imcType === 'itec') {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket_message_itec/${location.state.ticketId}`;
            } else if (
                (location.state.type === 'myTicket' || location.state.type === 'viewTicket') &&
                dbname === 'itec' &&
                !location.state.imcType
            ) {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket_message_itec/${location.state.ticketId}`;
            } else {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket_message/${location.state.imcType}/${location.state.ticketId}`;
            }
        } else {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket_message/${dbname}/${location.state.ticketId}`;
        }

        axios
            .get(baseURL, tokens)
            .then((response) => {
                if (response && response.data && response.data.message) {
                    //console.log('response---- IN PROGRESSS MESSAGES', response.data);
                    // setSelectedTicketDetails(response.data);
                    setMessagesList(response.data.message);
                }
                if (response && response.data && response.data.supportticket.issueId) {
                    setIssueType(response.data.supportticket.issueId.id);
                }
                if (response && response.data && response.data.supportticket) {
                    setSelectedTicketDetails(response.data.supportticket);
                }
                if (response && response.data && response.data.supportticket && response.data.supportticket.statusId) {
                    setStatusType(response.data.supportticket.statusId.statusText);
                    if (response.data.supportticket.statusId.statusText === 'Open') {
                        setMessageStatus(SupportOpen);
                    }
                    if (response.data.supportticket.statusId.statusText === 'In Progress') {
                        setMessageStatus(StageInprogress);
                    }
                    if (response.data.supportticket.statusId.statusText === 'Completed') {
                        setMessageStatus(SupportCompleted);
                    }
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    const downloadCoreFile = (file) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`, {
                // method: 'GET',
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })

            .then((response) => {
                const link = document.createElement('a');
                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                link.click();
            });
    };

    const getAMorPM = (val) => {
        let date = new Date(val);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    };

    const handleMessages = (e) => {
        setMessage(e.target.value);
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setTimeout(() => {
            setVisible(true);
        }, 1000);
    };

    const handleClose = () => {
        setShowLoader(false);
        setSuccessPop(false);
        setErrorPop(false);
    };

    const handleResolve = () => {
        const resolveReqObj = {
            message: 'Ticket has been resolved',
        };

        //console.log('ON RESOLVE ---- REQ OBJ', resolveReqObj);

        let baseURL = '';
        // if (usertype === 'itec') {
        //     baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/resolve_support_ticket_itec/${location.state.ticketId}`;
        // } else
        if (usertype === 'SUPERADMIN' || usertype === 'itec') {
            if (location.state.imcType === 'itec') {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/resolve_support_ticket_itec/${location.state.ticketId}`;
            } else {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/resolve_support_ticket/${location.state.imcType}/${location.state.ticketId}`;
            }
        } else {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/resolve_support_ticket/${dbname}/${location.state.ticketId}`;
        }

        axios
            .put(baseURL, resolveReqObj, tokens)
            .then((response) => {
                //console.log('RESOLVE TICKET', response.status);
                if (response.status === 200) {
                    setOpenResolveModal(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        if (usertype === 'SUPERADMIN' || usertype === 'itec') {
                            history.push({
                                pathname: '/menu/view-tickets',
                                state: { domainname },
                            });
                            setSuccessPop(false);
                        } else if (usertype === 'ADMIN') {
                            history.push('/menu/view-tickets');
                            setSuccessPop(false);
                        }
                    }, 1000);

                    // history.push('/menu/support-ticketlist');
                }
            })
            .catch((error) => {
                // console.error('There was an error!', error.response.data);
            });
    };

    // const handleBackBtn = () => {
    //     if (location.state.type === 'viewTicket') {
    //         // history.push('/menu/support-ticketstatus');
    //         history.push({
    //             pathname: '/menu/support-ticketstatus',
    //             state: { imcType: location.state.imcType },
    //         });
    //     } else {
    //         history.push('/menu/support-ticketlist');
    //     }
    // };
    const handleBackBtn = () => {
        if (location.state.type === 'viewTicket') {
            dispatch(setSelectedImc(location.state.imcType));
            // history.push({
            //     pathname: '/menu/support-ticketstatus',

            //     state: { imcType: location.state.imcType },
            // });
            if (usertype === 'SUPERADMIN' || usertype === 'itec') {
                history.push({
                    pathname: '/menu/view-tickets',
                    state: { domainname },
                });
            } else {
                history.push('/menu/view-tickets');
            }
        } else {
            history.push('/menu/support-ticketlist');
        }
    };

    const handleSubmit = () => {
        setShowLoader(true);
        if (
            (issueType === 3 && usertype === 'ADMIN' && location.state.type === 'viewTicket') ||
            (usertype === 'SUPERADMIN') ||
            (usertype === 'itec' && location.state.type === 'viewTicket')
        ) {
            const raiseTicketMessageObj = {
                messageText: message,
                supportticketId: location.state.ticketId,
            };

            let baseURL = '';
            // if (usertype === 'itec') {
            //     baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get-support-message_itec`;
            // } else
            if (usertype === 'SUPERADMIN' || usertype === 'itec') {
                if (location.state.imcType === 'itec') {
                    baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get-support-message_itec`;
                } else {
                    baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get-support-message/${location.state.imcType}`;
                }
            } else {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get-support-message/${dbname}`;
            }

            axios
                .post(baseURL, raiseTicketMessageObj, tokens)
                .then((response) => {
                    //console.log('SUBMIT MESSAGE ONLY', response.status);
                    if (response.status === 200) {
                        setShowLoader(false);
                        setOpenResolveModal(true);
                    }
                })
                .catch((error) => {
                    // console.error('There was an error!', error.response.data);
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowLoader(false);
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                    }
                });

            // setOpenResolveModal(true);
        } else {
            const raiseTicketMessageObj = {
                messageText: message,
                supportticketId: location.state.ticketId,
            };

            // setrequestdata(raiseTicketMessageObj);
            //console.log('ON SUBMIT ---- REQ OBJ', raiseTicketMessageObj);

            let baseURL = '';
            if (usertype === 'itec') {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get-support-message_itec`;
            } else if (usertype === 'SUPERADMIN') {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get-support-message/${location.state.imcType}`;
            } else {
                baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/get-support-message/${dbname}`;
            }

            axios
                .post(baseURL, raiseTicketMessageObj, tokens)
                .then((response) => {
                    // console.log('SUBMIT RAISE TICKET', response.status);
                    if (response.status === 200) {
                        setShowLoader(true);
                        if (usertype === 'ADMIN') {
                            history.push('/menu/support-ticketlist');
                        } else if (usertype === 'SUPERADMIN') {
                            history.push('/menu/support-ticketstatus');
                        } else {
                            history.push('/menu/support-ticketlist');
                        }
                    }
                })
                .catch((error) => {
                    setShowLoader(false);
                    // console.error('There was an error!', error.response.data);
                });
        }
    };

    const handleFeedbackClose = (val) => {
        let baseURL = '';
        if (usertype === 'itec') {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket_itec/${location.state.ticketId}`;
        } else if (usertype === 'SUPERADMIN') {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket/${location.state.imcType}/${location.state.ticketId}`;
        } else {
            baseURL = `${CommonConfig.dev.baseUrl5080}/api/support/support_ticket/${dbname}/${location.state.ticketId}`;
        }

        const feedbackObj = {
            areyouHappy: val,
        };

        axios
            .put(baseURL, feedbackObj, tokens)
            .then((response) => {
                //console.log('SUBMIT RAISE TICKET', response.status);
                if (response.status === 200) {
                    history.push('/menu/support-ticketlist');
                }
            })
            .catch((error) => {
                // console.error('There was an error!', error.response.data);
            });
    };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Ticket Resolved successfully" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}

            <Card className="client-card" style={{ height: '100%' }}>
                <CardContent className="client-heading">
                    <Typography variant="h5">Support</Typography>
                </CardContent>
                <CardContent>
                    {/* <CardHeader className="borderBottomLine ptb24" title="Support" /> */}
                    <Grid item container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.supCardImg}>
                                <img src={SupportImage} alt="Supportimage" />
                                <img src={messageStatus} alt="Supportopen" />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={3} className="main-container">
                                <Grid item xs={12} sm={12}>
                                    <div style={{ display: 'flex' }}>
                                        <Grid item xs={6} sm={3} className={classes.txtbold}>
                                            <Typography variant="span">Ticket Number:</Typography>
                                        </Grid>
                                        <Typography variant="span" className={classes.txtnormal}>
                                            {selectedTicketVal.ticketId}
                                        </Typography>
                                    </div>
                                    {usertype === 'SUPERADMIN' || usertype === 'itec' && location.state.type === 'viewTicket' ?
                                        <div style={{ display: 'flex' }}>
                                            <Grid item xs={6} sm={3} className={classes.txtbold}>
                                                <Typography variant="span">IMC Name:</Typography>
                                            </Grid>
                                            <Typography variant="span" className={classes.txtnormal} style={{ textTransform: 'capitalize' }}>
                                                {location.state.imcType ? location.state.imcType : dbname}
                                            </Typography>
                                        </div> : null}
                                    {location.state.type === 'viewTicket' ?
                                        <span>
                                            <div style={{ display: 'flex' }}>
                                                <Grid item xs={6} sm={3} className={classes.txtbold}>
                                                    <Typography variant="span">Client Id:</Typography>
                                                </Grid>
                                                <Typography variant="span" className={classes.txtnormal}>
                                                    {selectedTicketVal.clientId}
                                                </Typography>
                                            </div>
                                            <div style={{ display: 'flex' }}>
                                                <Grid item xs={6} sm={3} className={classes.txtbold}>
                                                    <Typography variant="span">Name:</Typography>
                                                </Grid>
                                                <Typography variant="span" className={classes.txtnormal}>
                                                    {selectedTicketVal.clientName}
                                                </Typography>
                                            </div>
                                            <div style={{ display: 'flex' }}>
                                                <Grid item xs={6} sm={3} className={classes.txtbold}>
                                                    <Typography variant="span">Email Id:</Typography>
                                                </Grid>
                                                <Typography variant="span" className={classes.txtnormal}>
                                                    {selectedTicketVal.clientEmailId}
                                                </Typography>
                                            </div>
                                            <div style={{ display: 'flex' }}>
                                                <Grid item xs={6} sm={3} className={classes.txtbold}>
                                                    <Typography variant="span">Mobile No:</Typography>
                                                </Grid>
                                                <Typography variant="span" className={classes.txtnormal}>
                                                    {selectedTicketVal.clientMobnumber}
                                                </Typography>
                                            </div>
                                        </span> : null}
                                    <div style={{ display: 'flex' }}>
                                        <Grid item xs={6} sm={3} className={classes.txtbold}>
                                            <Typography variant="span">Issue related to:</Typography>
                                        </Grid>
                                        <Typography variant="span" className={classes.txtnormal}>
                                            {selectedTicketVal.issueId && selectedTicketVal.issueId.issueType}
                                        </Typography>
                                    </div>
                                </Grid>
                                {/* <Grid item xs={6} sm={8} className={classes.txtnormal}>
                                    <div>
                                        <Typography variant="span">{selectedTicketVal.ticketId}</Typography>
                                    </div>
                                    <div>
                                        <Typography variant="span">{selectedTicketVal.clientId}</Typography>
                                    </div>
                                    <div>
                                        <Typography variant="span">{selectedTicketVal.clientName}</Typography>
                                    </div>
                                    <div>
                                        <Typography variant="span">{selectedTicketVal.clientEmailId}</Typography>
                                    </div>
                                    <div>
                                        <Typography variant="span">{selectedTicketVal.clientMobnumber}</Typography>
                                    </div>
                                    <div>
                                        <Typography variant="span">
                                            {selectedTicketVal.issueId && selectedTicketVal.issueId.issueType}
                                        </Typography>
                                    </div>
                                </Grid> */}
                            </Grid>

                            {/* <Grid item xs={6} sm={8} className={classes.txtnormal}>
                            {getTicketInProgressVal()}
                                </Grid> */}
                            {/* <span> */}
                            {messagesList && messagesList.length ? (
                                <div className={classes.overflowView}>
                                    {/* //className={classes.overflowView} */}
                                    {messagesList.map((message, messageIndex) => {
                                        return (
                                            <Grid container spacing={3} className="main-container ptb0">
                                                <Grid item xs={4} sm={2}>
                                                    <div className="bgBlue">
                                                        <div className="support-date">
                                                            <Typography gutterBottom variant="title">
                                                                {/* {new Date(message.createdOn).getDate()} */}
                                                                {moment(message.createdOn).format('DD')}
                                                            </Typography>
                                                        </div>
                                                        <div className="support-month">
                                                            <Typography variant="title" noWrap>
                                                                {moment(message.createdOn).format('MMM')}
                                                            </Typography>
                                                        </div>
                                                        <div className="support-time">
                                                            <Typography variant="title" noWrap>
                                                                {getAMorPM(message.createdOn)}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={8} sm={10}>
                                                    <div>
                                                        <Typography variant="Title" className={classes.txtbold}>
                                                            {message.messageByUserName ? <span>{message.messageByUserName}: </span> : ''}
                                                        </Typography>
                                                        <Typography variant="caption" className={classes.fontstyle}>
                                                            {message.messageText}
                                                        </Typography>
                                                    </div>
                                                    {selectedTicketVal && selectedTicketVal.attachDocuments && messageIndex === 0 ? (
                                                        <span style={{ display: 'flex' }}>
                                                            <div className={classes.fullWidth}>
                                                                <div>
                                                                    <FormControl className={classes.btnspace}>
                                                                        <Button
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            onClick={() => handlePreviewModal(selectedTicketVal.attachDocuments)}
                                                                            className={classes.button}
                                                                        >
                                                                            View attached document
                                                                        </Button>
                                                                    </FormControl>
                                                                </div>
                                                            </div>
                                                            {usertype === 'SUPERADMIN' && location.state.type === 'viewTicket' ?
                                                                <div onClick={() => downloadCoreFile(selectedTicketVal.attachDocuments)} style={{ paddingLeft: '9px', paddingTop: '9px' }}>
                                                                    <Tooltip title="Download">
                                                                        <img src={downloadImage} alt="downloadImage" className="downlaodImg downloadImgTop" />
                                                                    </Tooltip>
                                                                </div> : null}
                                                        </span>
                                                    ) : null}
                                                </Grid>
                                            </Grid>
                                        );
                                    })}
                                </div>
                            ) : null}

                            {/* </span> */}
                            {/* <Grid container spacing={3} className="main-container ptb0">
                                <Grid item xs={4} sm={2}>
                                    <div className="bgBlue">
                                        <div className="support-date">
                                            <Typography gutterBottom variant="title">
                                                08
                                            </Typography>
                                        </div>
                                        <div className="support-month">
                                            <Typography variant="caption" noWrap>
                                                Jan
                                            </Typography>
                                        </div>
                                        <div className="support-time">
                                            <Typography variant="caption" noWrap>
                                                08am
                                            </Typography>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={8} sm={10}>
                                    <div>
                                        <Typography variant="Title" className={classes.txtbold}>
                                            Advith:{' '}
                                        </Typography>
                                        <Typography variant="caption" className={classes.fontstyle}>
                                            Still am waiting for the response
                                        </Typography>
                                    </div> */}
                            {/* <div className={classes.fullWidth}>
                                        <FormControl className={classes.btnspace}>
                                            <Button variant="outlined" color="primary" className={classes.button}>
                                                View attached document
                                            </Button>
                                        </FormControl>
                                    </div> */}
                            {/* </Grid>
                            </Grid> */}
                            {statusType === 'Completed' || (usertype === 'ADMIN' && selectedTicketVal && selectedTicketVal.clientType === "EMPLOYEE") ? null : (
                                <span>
                                    {(issueType === 3 && usertype === 'ADMIN' && location.state.type === 'viewTicket') ||
                                        (usertype === 'ADMIN' && location.state.type === 'myTicket') ||
                                        usertype === 'itec' ||
                                        (usertype === 'INDIVIDUAL' && location.state.type === 'myTicket') ||
                                        (usertype === 'CORPORATE' && location.state.type === 'myTicket') ||
                                        (usertype === 'SUPERADMIN') ||
                                        (usertype === 'CORETEAM' && location.state.type === 'myTicket') ? (
                                            <Grid container spacing={3} className="main-container">
                                                <Grid item xs={12} sm={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel className="lbl" htmlFor="description" shrink>
                                                            Message
                                                    </InputLabel>
                                                        <Input
                                                            type="text"
                                                            className="bottom"
                                                            placeholder="Enter Message"
                                                            name="message"
                                                            onChange={(e) => {
                                                                handleMessages(e);
                                                            }}
                                                            inputProps={{ maxLength: 150 }}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        ) : null}
                                </span>
                            )}
                            {selectedTicketVal && selectedTicketVal.areyouHappy ? (
                                <Grid container spacing={3} className="main-container">
                                    <Grid item xs={12} sm={12}>
                                        <span className={classes.txtbold} style={{ paddingRight: '22px' }}>
                                            Feedback{' '}
                                        </span>
                                        <span>{selectedTicketVal.areyouHappy}</span>
                                    </Grid>
                                </Grid>
                            ) : null}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <PreviewModal fileSource={downloadFile} visibleClose={visible} handleModalClose={handleModalClose} />

            <div className="footer-button">
                <ul>
                    <li>
                        {/* {usertype}{issueType} */}
                        <Button color="primary" className="buttonnext txt-cap" onClick={handleBackBtn}>
                            Back
                        </Button>
                    </li>
                    {location.state.type === 'viewTicket' ? null : (
                        <span>
                            {statusType === 'Completed' && selectedTicketVal && !selectedTicketVal.areyouHappy ? (
                                <li>
                                    {/* {usertype}{issueType} */}
                                    <Button
                                        color="primary"
                                        className="buttonnext txt-cap"
                                        onClick={() => {
                                            setOpenModal(true);
                                        }}
                                    >
                                        Give Feedback
                                    </Button>
                                </li>
                            ) : //  }
                                null}
                        </span>
                    )}
                    <li>
                        {statusType === 'Completed' || (usertype === 'ADMIN' && selectedTicketVal && selectedTicketVal.clientType === "EMPLOYEE") ? null : (
                            <span>
                                {(issueType === 3 && usertype === 'ADMIN' && location.state.type === 'viewTicket') ||
                                    (usertype === 'ADMIN' && location.state.type === 'myTicket') ||
                                    usertype === 'itec' ||
                                    (usertype === 'INDIVIDUAL' && location.state.type === 'myTicket') ||
                                    (usertype === 'CORPORATE' && location.state.type === 'myTicket') ||
                                    (usertype === 'SUPERADMIN') ||
                                    (usertype === 'CORETEAM' && location.state.type === 'myTicket') ? (
                                        <Button
                                            color="primary"
                                            className={!message.length ? classes.disableBtn : 'buttonnext txt-cap'}
                                            onClick={handleSubmit}
                                        >
                                            Submit
                                    </Button>
                                    ) : null}
                            </span>
                        )}
                    </li>
                    {/* <li>
                        {((issueType === 3) && usertype === "ADMIN" && location.state.type === 'viewTicket') || ((issueType === 1 || issueType === 2) && usertype === "SUPERADMIN") ?
                            <Button color="primary" className="buttonnext txt-cap" onClick={handleResolve}>
                                Resolve
                        </Button> : null}
                    </li> */}
                </ul>
                <Dialog
                    onClose={() => {
                        setOpenResolveModal(false);
                    }}
                    PaperProps={{
                        className: 'QandADailogBox dailogView',
                        style: { padding: '20px', width: '60%' },
                    }}
                    aria-labelledby="form-dialog-title"
                    open={openResolveModal}
                >
                    {/* <h3 className="filename" style={{ marginTop: '0px', padding: '0px 11px' }}>
                        Please confirm
                </h3> */}

                    {/* <div style={{ alignItems: 'start', margin: '5px 0px 5px 10px' }}>
                </div> */}
                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            className={classes.popContent}
                            style={{ fontWeight: '500', fontFamily: 'Rubik' }}
                        >
                            Your message has been successfully submitted. If the ticket is resolved, please click on Resolved button.
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions className="paddingBtm" style={{ justifyContent: 'flex-start' }}>
                        <Button className={classes.buttonView} onClick={handleBackBtn}>
                            Cancel
                        </Button>
                        <Button className={classes.buttonView} onClick={handleResolve}>
                            Resolved
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    onClose={() => {
                        setOpenModal(false);
                    }}
                    PaperProps={{
                        className: 'QandADailogBox dailogView dailogMargin',
                        style: { padding: '20px', width: '60%' },
                    }}
                    aria-labelledby="form-dialog-title"
                    open={openModal}
                >
                    <h3 className="filename" style={{ marginTop: '0px', padding: '0px 11px' }}>
                        Feedback
                    </h3>

                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            className={classes.popContent}
                            style={{ fontWeight: '500', fontFamily: 'Rubik' }}
                        >
                            Are you happy with the resolution given?
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions className="paddingBtm" style={{ justifyContent: 'flex-start' }}>
                        <Button
                            className={classes.widthView}
                            onClick={() => {
                                handleFeedbackClose('No');
                            }}
                            variant="contained"
                            component="label"
                            color="default"
                        >
                            No
                        </Button>
                        <Button
                            className={classes.widthView}
                            onClick={() => {
                                handleFeedbackClose('Yes');
                            }}
                            variant="contained"
                            component="label"
                            color="default"
                        >
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    );
}
